<mat-card class="xp-drawer__panel"
          role="dialog"
          [attr.aria-labelledby]="header()?.headingId"
          [attr.aria-label]="ariaLabel() || null"><ng-content></ng-content></mat-card>
